module.exports = __webpack_public_path__ + "img/oct-red.d3f8f086.svg";